/**
 * Admin constants - possible values for admin forms and dropdowns
 */

/** subscription_plans.vendor - valid vendor values */
export const SUBSCRIPTION_PLANS_VENDORS = [
  'MoneyMinder',
  'Squarespace',
  'Foundation',
  '501C University',
  'TaxDome',
  'GrantStation',
  'Agent Service', 
  'Harbor Compliance', 
  'Circle', 
  'Compliance',
  'DEMO',
];

/** subscription_plans.term - valid term values */
export const SUBSCRIPTION_PLANS_TERMS = [
  'annual',
  'monthly',
];

/** inbound_payloads.status - valid status values */
export const INBOUND_PAYLOAD_STATUSES = [
  'new',
  'processing',
  'failed',
  'complete',
];

/** subscriptions.source - valid source values (referral/acquisition channel) */
export const SUBSCRIPTION_SOURCES = [
  'MoneyMinder',
  'Squarespace',
  'Foundation',
  '501C University',
  'TaxDome',
  'GrantStation',
  'Agent Service', 
  'Harbor Compliance', 
  'Circle', 
  'Compliance',
  'DEMO', 
];
